import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useVendorStore from "components/core/HomePage/useVendorStore";
import useAuthStore from "components/core/Auth/useAuthStore";
import { LS_KEYS } from "utils/constants/localStorageKeys";
import { zSpacing } from "components/shared/tokens/spacing";
import { ProfileContainer, ScrollArea, HeaderBar, TopProfileCard, SmallText, FieldValue, SectionHeading, OutletList, OutletCard, OutletTitle, OutletAddress, OutlineActionButton, ActionButtonContent, IconWrapper } from "./styles.profile";

const Profile = () => {
  const navigate = useNavigate();
  const sellerDetails = useVendorStore((state) => state.sellerDetails);
  const getSellerDetails = useVendorStore((state) => state.getSellerDetails);
  const sellerProfile = useVendorStore((state) => state.sellerProfile);
  const getSellerProfile = useVendorStore((state) => state.getSellerProfile);
  const outletId = window.localStorage.getItem(LS_KEYS.OUTLET_ID);

  useEffect(() => {
    getSellerDetails({ phone_number: window.localStorage.getItem("phone_number") });
    getSellerProfile();
  }, []);
  const userName = sellerProfile?.user_name || "";
  const phoneNumber = sellerProfile?.phone_number || "";
  const email = sellerProfile?.user_email || "";

  const currentSellerDetail = useMemo(() => {
    if (!sellerDetails?.seller_outlet_details) return {};
    return sellerDetails.seller_outlet_details.find(
      (item) => item.outlet_id == outletId
    ) || {};
  }, [sellerDetails, outletId]);

  const outlets = useMemo(() => {
    return sellerDetails?.seller_outlet_details || [];
  }, [sellerDetails]);

  const handleLogout = () => {
    useAuthStore.getState().signOut();
  };

  const handleDeleteAccount = () => {
    navigate("/delete-account");
  };

  return (
    <ProfileContainer>
      <ScrollArea>
        <TopProfileCard>
          <HeaderBar onClick={() => navigate(-1)}>
            <img src="/logos/back_logo.svg" alt="Back" width={20} height={20} />
            <span>Profile settings</span>
          </HeaderBar>

          <div style={{ marginTop: zSpacing.z4 }}>
            <div style={{ marginBottom: zSpacing.z3 }}>
              <SmallText>User name</SmallText>
              <FieldValue>{userName || "-"}</FieldValue>
            </div>
            <div style={{ marginBottom: zSpacing.z3 }}>
              <SmallText>Login phone number</SmallText>
              <FieldValue>{phoneNumber || "-"}</FieldValue>
            </div>
            <div>
              <SmallText>Email address</SmallText>
              <FieldValue>{email || "-"}</FieldValue>
            </div>
          </div>
        </TopProfileCard>

        <div style={{ padding: `0 ${zSpacing.z3}` }}>
          <SectionHeading>
            <img src="/logos/line.png" alt="line" style={{ width: "32px", height: "1px", objectFit: "contain" }} />
            YOUR OUTLETS
            <img src="/logos/line.png" alt="line" style={{ width: "32px", height: "1px", objectFit: "contain" }} />
          </SectionHeading>

          <OutletList>
            {outlets.map((outlet) => (
              <OutletCard key={outlet.outlet_id || outlet.outlet_name}>
                <OutletTitle>{outlet.outlet_name || "Outlet"}</OutletTitle>
                <OutletAddress>
                  {[outlet.address, outlet.city, outlet.state, outlet.zip_code]
                    .filter(Boolean)
                    .join(", ")}
                </OutletAddress>
              </OutletCard>
            ))}
          </OutletList>

          <div style={{ marginTop: zSpacing.z4, display: "flex", flexDirection: "column", gap: zSpacing.z3, paddingBottom: zSpacing.z5 }}>
            <OutlineActionButton type="button" onClick={handleDeleteAccount}>
              <ActionButtonContent>
                <IconWrapper>
                  <img src="/logos/trash_logo.svg" alt="Delete" width={18} height={18} />
                </IconWrapper>
                Delete account
              </ActionButtonContent>
            </OutlineActionButton>
            
            <OutlineActionButton type="button" onClick={handleLogout}>
              <ActionButtonContent>
                <IconWrapper>
                  <img src="/logos/logout.svg" alt="Logout" width={18} height={18} />
                </IconWrapper>
                Logout
              </ActionButtonContent>
            </OutlineActionButton>
          </div>
        </div>
      </ScrollArea>
    </ProfileContainer>
  );
};

export default Profile;